// The address the last session in this browser held, so a person whose session
// ended by itself meets a sign-in page that already knows who they were (#2054).
//
// It is browser state and no server answer: written from `/me` once a session is
// signed in, never from what a person typed, so a mistyped address is never kept.
// Sign out and Switch user forget it; an expiry does not, which is the case it
// exists for (option A, ruled 2026-10-27, for a shared machine). Every read and
// write is wrapped, because storage can be blocked, and the page then draws
// today's empty address field.
const KEY = "zenith.remembered-address";

export function rememberedAddress(): string | undefined {
  try { return localStorage.getItem(KEY) || undefined; } catch { return undefined; }
}

export function rememberAddress(address: string) {
  try { localStorage.setItem(KEY, address); } catch { /* private mode */ }
}

/** Forgets the address; called at sign-out and by Switch user. */
export function forgetAddress() {
  try { localStorage.removeItem(KEY); } catch { /* private mode */ }
}
